import { Label } from '@/components/ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';

import { PROMPT_TEMPLATES } from '../model/promptTemplates';

interface Props {
  id?: string;
  value: string;
  onChange: (id: string) => void;
  label?: string;
}

const PromptTypeSelect = ({ id, value, onChange, label = 'Tipo de prompt' }: Props) => (
  <div className="space-y-1">
    {label && <Label htmlFor={id}>{label}</Label>}
    <Select value={value} onValueChange={onChange}>
      <SelectTrigger id={id}>
        <SelectValue placeholder="Selecciona un tipo" />
      </SelectTrigger>
      <SelectContent>
        {PROMPT_TEMPLATES.map((template) => (
          <SelectItem key={template.id} value={template.id}>
            {template.label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  </div>
);

export default PromptTypeSelect;
